<template>
    <div class="tasks-list-wrapper">
        <h1>{{$t('tests.wizard.area_step.headline')}}</h1>
        <p class="subtitle">{{$t('tests.wizard.area_step.subtext', {max: maxAreas})}}</p>
        <tests-areas-canvas :test-areas="$parent.test.areas" :max-areas="maxAreas" v-model="isButtonDisabled"
                            ref="areasCanvas"></tests-areas-canvas>

        <tests-wizard-buttons-block :next="nextStep" :previous="$parent.previousStep"
                                    :isButtonDisabled="isButtonDisabled"></tests-wizard-buttons-block>
    </div>
</template>

<script>
    export default {
        name: 'tests-wizard-area-step',
        data() {
            return {
                maxAreas: 3,
                isButtonDisabled: true
            }
        },
        methods: {
            nextStep() {
                this.$parent.test.areas = _.map(this.$refs.areasCanvas.areas, area => area.transformToSave());
                this.$parent.updateTest();
            }
        }
    }
</script>

<style scoped>

</style>